/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Addons_DescInputs */

const en_billing_addons_desc = /** @type {(inputs: Billing_Addons_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-ups are used after your plan quota runs out and never expire.`)
};

const id_billing_addons_desc = /** @type {(inputs: Billing_Addons_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-up dipakai setelah kuota paket habis dan tidak kedaluwarsa.`)
};

/**
* | output |
* | --- |
* | "Top-ups are used after your plan quota runs out and never expire." |
*
* @param {Billing_Addons_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addons_desc = /** @type {((inputs?: Billing_Addons_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addons_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addons_desc(inputs)
	return en_billing_addons_desc(inputs)
});